import React from 'react'
import Edit from '../crud/edit'
import menuItems from './menuItems'

const fields = [
  {
    name: 'Default Institution HTML Block',
    prop: 'value',
    type: 'textarea'
  }
]

const EditSettings = (props) => {
  return (
    <Edit
// @ts-ignore
      title='Edit Default Institution HTML Block'
      fields={fields}
      apiPath='admin/settings/default_institution_html_block'
      successRedirectPath='/settings'
      buildMenuItems={menuItems}
      disableDelete
    />
  )
}

export default EditSettings
